module.exports = __webpack_public_path__ + "img/banner1.81647003.png";